/**
 * Los dos textos de la pantalla de inicio que se arman en vez de mostrarse.
 *
 * Van aparte porque es la primera pantalla que alguien abre al entrar, y las
 * dos formas de que quede mal —un avatar en blanco, un «1 ventas»— no rompen
 * nada: se ven.
 */

/**
 * `JP` para «Juan Perez». Es el `getInitials` de `imprenta`, con el filtro que
 * allá falta.
 *
 * `"Juan  Perez".split(" ")` devuelve una cadena vacía en el medio, y su
 * primera letra es `undefined`. En el `join` desaparece, así que el resultado
 * sale bien de casualidad — pero `slice(0, 2)` se aplica DESPUÉS, y con
 * espacios al principio son los `undefined` los que ocupan los dos primeros
 * lugares. Filtrar las vacías primero es lo que hace que el caso raro no
 * dependa de la suerte.
 */
export function iniciales(nombre: string): string {
  return nombre
    .split(" ")
    .filter((parte) => parte !== "")
    .slice(0, 2)
    .map((parte) => parte[0] ?? "")
    .join("")
    .toUpperCase();
}

/** «Realizaste 7 ventas este mes.» — el subtítulo de «Ventas Recientes». */
export function resumenDeVentas(cantidad: number): string {
  return `Realizaste ${cantidad} ${cantidad === 1 ? "venta" : "ventas"} este mes.`;
}
